var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { useEffect } from 'react';
export var getAuthDataFromLocalStorage = function () {
    var token = localStorage.getItem('credenciamento:admin:authToken');
    var provider = localStorage.getItem('credenciamento:admin:authProvider');
    return { token: token, provider: provider };
};
export var saveAuthDataToLocalStorage = function (token, provider) {
    localStorage.setItem('credenciamento:admin:authToken', token);
    localStorage.setItem('credenciamento:admin:authProvider', provider);
};
export var clearAuthDataFromLocalStorage = function () {
    localStorage.removeItem('credenciamento:admin:authToken');
    localStorage.removeItem('credenciamento:admin:authProvider');
};
export var handleLogin = function (provider, keycloak, navigate) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(provider === 'mt-login')) return [3 /*break*/, 2];
                return [4 /*yield*/, keycloak.login({
                        redirectUri: "".concat(process.env.REACT_APP_URL_PROJETO, "/"),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                navigate('/login-otp');
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var handleLogout = function (provider, keycloak, navigate, clearUserInfo) {
    clearAuthDataFromLocalStorage();
    clearUserInfo();
    if (provider === 'mt-login') {
        keycloak.logout();
    }
    else {
        clearAuthDataFromLocalStorage();
        clearUserInfo();
    }
};
export var useSetupInterceptors = function (axiosInstance, navigate, addMessage) {
    useEffect(function () {
        var resInterceptor = function (response) { return response; };
        var errInterceptor = function (error) {
            if (error.isAxiosError && axios.isCancel(error)) {
                return Promise.reject(error);
            }
            var message = 'Ocorreu um erro';
            var status = 'error';
            if (error.response) {
                var statusCode = error.response.status;
                if (statusCode === 403) {
                    navigate('/acesso-negado');
                    return Promise.reject(error);
                }
                if (statusCode === 401) {
                    navigate('/login');
                    return Promise.reject(error);
                }
                if (statusCode >= 400 && statusCode <= 499) {
                    status = 'warning';
                }
                else if (statusCode >= 500 && statusCode <= 599) {
                    status = 'error';
                }
                var errorData = error.response.data;
                if (errorData.message instanceof Array) {
                    message = errorData.message.join('\n');
                }
                else if (typeof errorData.message === 'string') {
                    message = errorData.message;
                }
            }
            else if (error.message === 'Network Error') {
                status = 'error';
                message = 'Serviço indisponível. Tente novamente mais tarde.';
            }
            else {
                message = error.message;
            }
            console.error(status, error);
            addMessage(status, message);
            return Promise.reject(error);
        };
        var interceptor = axiosInstance.interceptors.response.use(resInterceptor, errInterceptor);
        return function () { return axiosInstance.interceptors.response.eject(interceptor); };
    }, [addMessage, navigate]);
};
